import script from "./BaseFiltersCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFiltersCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./BaseFiltersCheckbox.vue?vue&type=style&index=0&id=54c3bab0&scoped=true&lang=scss"

import exportComponent from "/Users/acatohw/Development/openwebconcept/app/public_html/wp-content/plugins/openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c3bab0"]])

export default __exports__